import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  list: {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
  },
});
